import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartByOrg: {}, 
  email: "",
};

export const cartSlice = createSlice({
  name: "Cart",
  initialState,
  reducers: {
    addItemToCart: (state, action) => {
      const { orgId, item } = action.payload;
    
      if (!state.cartByOrg) {
        state.cartByOrg = {};
      }
    
      if (!state.cartByOrg[orgId]) {
        state.cartByOrg[orgId] = [];
      }
    
      const existingItem = state.cartByOrg[orgId].find((i) => i.id === item.id);
    
      if (existingItem) {
        existingItem.quantity += 1;
        existingItem.totalDue += parseFloat(item.price);
      } 
      else {
        state.cartByOrg[orgId].push({
          ...item,
          quantity: 1,
          totalDue: parseFloat(item.price),
        });
      }
    },
    
       
    addTenItemToCart: (state, action) => {
      const { orgId, item } = action.payload;

      if (!state.cartByOrg) {
        state.cartByOrg = {};
      }
    
      if (!state.cartByOrg[orgId]) {
        state.cartByOrg[orgId] = [];
      }

      const existingItem = state.cartByOrg[orgId].find((i) => i.id === item.id);
      
      if (existingItem) {
        existingItem.quantity += 10;
        existingItem.totalDue += parseFloat(item.price * 10);
      } 
      else {
        state.cartByOrg[orgId].push({
          ...item,
          quantity: 10,
          totalDue: parseFloat(item.price * 10),
        });
      }
    },

    removeItemFromCart: (state, action) => {
      const { orgId, item } = action.payload;

      if (!state.cartByOrg[orgId]) {
        state.cartByOrg[orgId] = [];
      }

      const existingItem = state.cartByOrg[orgId].find((i) => i.id === item.id);

      if (existingItem && existingItem.quantity === 1) {
        state.cartByOrg[orgId] = state.cartByOrg[orgId].filter(
          (i) => i.id !== item.id
        );
      } 
      else if (existingItem) {
        existingItem.quantity -= 1;
        existingItem.totalDue -= parseFloat(item.price);
      }
    },

    emptyWholeCart: (state, action) => {
      const { orgId } = action.payload;
      state.cartByOrg[orgId] = [];
    },

    setEmail: (state, action) => {
      state.email = action.payload;
    },

    clearEmail: (state) => {
      state.email = "";
    },
  },
});

export const {
  addItemToCart,
  addTenItemToCart,
  removeItemFromCart,
  emptyWholeCart,
  setEmail,
  clearEmail,
} = cartSlice.actions;

export const getCartArray = (state, orgId) => state.Cart.cartByOrg[orgId] || [];
export const getEmail = (state) => state.Cart.email;

export default cartSlice.reducer;
